import React from 'react';
import moment from 'moment';
import SmallSpinner from '../../shared/SmallSpinner';

type Props = {
    lastAnalyzed: string | null;
    isLoading?: boolean;
};

export default function ServiceableUrlsLastAnalyzedCell({ lastAnalyzed, isLoading }: Props) {
    return (
        <>
            {isLoading && <SmallSpinner />}
            {!isLoading && <div className="action-button-column">{lastAnalyzed && moment(lastAnalyzed).format('MMM DD, YYYY')}</div>}
        </>
    );
}
